/**
 * Returns the union (combination) of all the iterables into one set. Useful for deduplicating
 * multiple collections.
 */
export const unionSet = <T>(...iterables: Iterable<T>[]): Set<T> => {
  const set = new Set<T>();

  for (const iterable of iterables) {
    for (const value of iterable) {
      set.add(value);
    }
  }

  return set;
};

/**
 * Returns the difference of minuend set and subtrahend set.
 *
 * Note that duplicates are removed from the minuend even if they aren't in the subtrahend. E.g. [
 * 1, 2, 2, 3, 4 ] - [3, 4, 5] = { 1, 2 }
 */
export const differenceSet = <T>(minuend: Iterable<T>, subtrahend: Iterable<T>): Set<T> => {
  const set = new Set<T>(minuend);

  for (const value of subtrahend) {
    set.delete(value);
  }

  return set;
};
